import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/modern-normalize/modern-normalize.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/font/local/target.css?{\"path\":\"lib/fonts/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"./JuliettaMessie/font.woff2\",\"display\":\"swap\",\"variable\":\"--font-julietta-messie\"}],\"variableName\":\"juliettamessie\"}");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/font/local/target.css?{\"path\":\"lib/fonts/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"./icons/bootstrap-icons.woff2\",\"display\":\"swap\",\"variable\":\"--font-bootstrap-icons\"}],\"variableName\":\"bootstrapIcons\"}");
